import state from './state';
import * as getters from './getters';
import actions from './actions';
import mutations from './mutations';
import EventInsightsStore from '@/modules/reporting/event-insights/store';

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    eventInsights: EventInsightsStore
  }
};